export default [
  {
    path: '/userAgreement',
    name: 'userAgreement',
    component: require('@/views/userAgreement/index').default,
    meta: {
      title: '用户协议',
      pageName: '用户协议列表',
      page: 'page_user_agreement',
      pageData: ['namespace'],
    },
  },
  {
    path: '/userAgreement/detail',
    name: 'userAgreementDetail',
    component: require('@/views/userAgreement/detail').default,
    meta: {
      title: '协议详情',
      pageName: '协议详情',
      page: 'page_user_agreement_detail',
      pageData: ['namespace', 'sign_id'],
    },
  },
];
